import { getRegionConfig } from "@/lib/regionConfig";

const regionConfig = getRegionConfig();

export interface FeedbackOrderInfo {
  order: {
    reference?: string | null;
    type?: string | null;
    scheduled_at?: string | null;
    vehicle_model?: string | null;
    vehicle_plate?: string | null;
    driver_name?: string | null;
    completed_at?: string | null;
  };
  submitted: boolean;
  feedback?: {
    handover_rating?: number | null;
    attitude_rating?: number | null;
    explanation_rating?: number | null;
    comment?: string | null;
    tip_amount?: number | string | null;
    tip_payment_status?: string | null;
    tip_payment_url?: string | null;
  } | null;
}

export interface FeedbackPayload {
  handover_rating: number;
  attitude_rating: number;
  explanation_rating: number;
  comment?: string;
  tip_amount?: number;
}

export interface AutosavePayload {
  handover_rating?: number;
  attitude_rating?: number;
  explanation_rating?: number;
  comment?: string;
  tip_amount?: number;
}

export interface SubmitResponse {
  message: string;
  tip_payment_url?: string | null;
}

async function parseResponse<T>(response: Response): Promise<T> {
  const json = await response.json();

  if (!response.ok) {
    throw json;
  }

  return json;
}

export async function getFeedbackInfo(token: string): Promise<FeedbackOrderInfo> {
  const response = await fetch(`${regionConfig.apiUrl}delivery/feedback/${token}`, {
    headers: { Accept: "application/json" },
  });

  return parseResponse<FeedbackOrderInfo>(response);
}

export async function autosaveFeedback(token: string, payload: AutosavePayload): Promise<{ saved: boolean }> {
  const response = await fetch(`${regionConfig.apiUrl}delivery/feedback/${token}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });

  return parseResponse<{ saved: boolean }>(response);
}

export async function submitFeedback(token: string, payload: FeedbackPayload): Promise<SubmitResponse> {
  const response = await fetch(`${regionConfig.apiUrl}delivery/feedback/${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });

  return parseResponse<SubmitResponse>(response);
}
